import { render, staticRenderFns } from "./LoadingPopupWithAsyncFallback.vue?vue&type=template&id=be9a6076&scoped=true&"
import script from "./LoadingPopupWithAsyncFallback.vue?vue&type=script&lang=js&"
export * from "./LoadingPopupWithAsyncFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9a6076",
  null
  
)

export default component.exports